import { render, staticRenderFns } from "./docked-foldout.vue?vue&type=template&id=1286394b&scoped=true&"
import script from "./docked-foldout.vue?vue&type=script&lang=ts&"
export * from "./docked-foldout.vue?vue&type=script&lang=ts&"
import style0 from "./docked-foldout.vue?vue&type=style&index=0&id=1286394b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1286394b",
  null
  
)

export default component.exports